module.exports = "<div class=\"grouping-order-popup\">\r\n    <create-edit-popup options=\"options\"></create-edit-popup>\r\n</div>"